import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmartTireMainComponent } from '../smart-tire-main/smart-tire-main.component';
import { SmarttireDisclaimerComponent } from '../smarttire-disclaimer/smarttire-disclaimer.component';
import { SmarttireFleetInfoComponent } from '../smarttire-fleet-info/smarttire-fleet-info.component';
import { SmarttireLeftComponent } from '../smarttire-left/smarttire-left.component';
import { SmarttireMaintainceInfoComponent } from '../smarttire-maintaince-info/smarttire-maintaince-info.component';
import { SmarttireSavingsInfoComponent } from '../smarttire-savings-info/smarttire-savings-info.component';
import { SmarttireTooltipComponent } from '../smarttire-tooltip/smarttire-tooltip.component';
import { SmarttireVistorInfoComponent } from '../smarttire-vistor-info/smarttire-vistor-info.component';

import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { I18nModule, FeaturesConfigModule, UrlModule, ConfigModule, CmsConfig } from '@spartacus/core';
import { AtMessageModule, IconModule, ItemCounterModule, ListNavigationModule, MediaModule, OutletModule, OutletRefModule, PageComponentModule, SpinnerModule, StarRatingModule, PageLayoutModule } from '@spartacus/storefront';
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { EnvironmentService } from 'src/app/services/environment.service';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbsmartireEmailComponent } from '../kb-smarttire-email/kbsmartire-email/kbsmartire-email.component';



@NgModule({
  declarations: [
    SmartTireMainComponent,
    SmarttireDisclaimerComponent,
    SmarttireFleetInfoComponent,
    SmarttireLeftComponent,
    SmarttireMaintainceInfoComponent,
    SmarttireSavingsInfoComponent,
    SmarttireTooltipComponent,
    SmarttireVistorInfoComponent,
    KbsmartireEmailComponent

  ],
  imports: [
    CommonModule,
       I18nModule,
       ReactiveFormsModule,
       AtMessageModule,
       FeaturesConfigModule,
       IconModule,
       InfiniteScrollModule,
       ItemCounterModule,
       ListNavigationModule,
       MediaModule,
       OutletModule,
       OutletRefModule,
       PageComponentModule,
       RouterModule,
       SpinnerModule,
       StarRatingModule,
       UrlModule,
       TooltipModule,
       MatDialogModule,
       MatButtonModule,
       MatIconModule,
       PageLayoutModule,
       RecaptchaModule,
       RecaptchaFormsModule,
   
       ConfigModule.withConfig({
         cmsComponents: {
          KbSmartTireFlexComponent: {
             component: SmartTireMainComponent, guards: [SecureGuard]
           }
         }
       } as CmsConfig)
     ],
     providers: [ {
       provide: RECAPTCHA_SETTINGS,
       useFactory: (config: EnvironmentService): RecaptchaSettings => {
         return { siteKey: config.getConfig().googleReCaptchaKey };
       },
       deps: [EnvironmentService],
     },
     ],
   })
export class KbSmartTireModule { }
